import { type FC, type ComponentProps } from "react";
import { TextArea } from "@root/shared/components/TextArea";
import { CheckboxAndText } from "@clientFrontend/features/publication/components/WelfareInputsCheckboxAndText";
import { InformationText } from "@root/shared/components/InformationText";
import * as commonStyles from "@clientFrontend/features/publication/styles/styles.css";
import { type UniformInputsProps } from "./type";

type Props = UniformInputsProps & ComponentProps<typeof CheckboxAndText>;

export const Presentation: FC<Props> = ({
  formNames,
  inputValues,
  errors,
  value,
  text,
  checked,
  handleChangeCheckbox,
  handleInputChange,
  parentCheckboxId,
}) => {
  return (
    <div className={commonStyles.container}>
      <CheckboxAndText
        checked={checked}
        text={text}
        value={value}
        hasError={errors && Object.keys(errors).length > 0}
        onChange={(e) => handleChangeCheckbox(e.target.checked)}
        id={parentCheckboxId}
        name="work_requirement[welfares][]"
      />
      <div className={checked ? commonStyles.detailForm : commonStyles.detailFormDisabled}>
        <section className={commonStyles.detailFormSection}>
          <h3 className={commonStyles.detailFormTitle}>支給条件</h3>
          <div className={commonStyles.detailFormBodySingleBox}>
            <dl className={commonStyles.detailFormList}>
              <dd className={commonStyles.detailItem}>
                <TextArea
                  name={formNames.uniformProvidingConditions}
                  id={formNames.uniformProvidingConditions}
                  value={inputValues?.uniformProvidingConditions}
                  hasError={errors && Object.keys(errors).length > 0}
                  placeholder="入力してください"
                  size="small"
                  disabled={!checked}
                  onChange={(e) => handleInputChange("uniformProvidingConditions", e.target.value)}
                />
              </dd>
            </dl>
          </div>
          {errors?.uniformProvidingConditions && (
            <InformationText
              className={commonStyles.error}
              isAlert
              text={errors.uniformProvidingConditions}
            />
          )}
        </section>
      </div>
    </div>
  );
};
